// action
import {
    BOOK_APPOINTMENT,
    BOOK_APPOINTMENT_FAIL,
    BOOK_APPOINTMENT_SUCCESS,
    BOOK_APPOINTMENT_RESET
} from '../action/bookAppointmentAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action) {
    switch (action.type) {
        case BOOK_APPOINTMENT:
            return {
                ...state,
                apiState: "loading"
            }
        case BOOK_APPOINTMENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case BOOK_APPOINTMENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case BOOK_APPOINTMENT_RESET:
            return initialState
        default:
            return state
    }
}